import styled from "@emotion/styled/macro";
import { Box } from "@mui/material";
import isStyledPropsValid from "utils/isStyledPropsValid";
import TextWithTooltip from "components/Text/TextWithTooltip";

//
// Ticket Detail
//
export const StyledTicketDetailContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    height: "100%",
    borderRadius: "8px",
    overflow: "hidden",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      overflowY: "auto",
    },
  };
});

export const StyledMessageInfoContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    width: "240px",
    padding: "12px",
    borderRight: "1px solid #e6e6e6",
    backgroundColor: "white",
    borderRadius: "8px 0 0 8px",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    position: "relative",
  };
});

export const StyledChatAreaContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  flex: 1,
  position: "relative",
  height: "100%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const StyledUserInfoContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  display: "flex",
  height: "100%",
  width: "100%",
  overflow: "auto",
  flexDirection: "column",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    height: "100vh",
  },
}));

//
// Ticket List Item
//
export const StyledTicketListItemContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  marginTop: "8px",
  paddingBottom: "8px",
  borderBottom: "1px solid #E6E6E6",
  cursor: "pointer",
  position: "relative",
}));

export const StyledTicketContent = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, isSelected }) => ({
  borderRadius: "4px",
  padding: "8px",
  backgroundColor: isSelected ? "#FAF6FF" : "white",
}));

export const StyledTicketMetaContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  fontSize: "10px",
  color: "#555",
  marginTop: "12px",
  fontWeight: 500,
}));
